import { SegmentBasedEntry } from "../../SegmentBasedEntry/SegmentBasedEntry.js";
async function SegmentBasedEntryFlyout({
  entry,
  locale
}) {
  var _a;
  if (!entry) {
    console.error("SegmentBasedEntryFlyout error: Invalid entry.");
    return null;
  }
  const uid = (_a = entry.segment_based_entry_ref[0]) == null ? void 0 : _a.uid;
  return await SegmentBasedEntry({
    entryId: uid,
    locale,
    adBuilderSx: { flex: 0 }
  });
}
export {
  SegmentBasedEntryFlyout
};
